// api/configApi.ts
import { baseApi } from "./BaseApi";
import { CreateCheckoutRequest, SessionStatus } from "../types/checkoutTypes";

const checkoutApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    createCheckoutSession: builder.mutation<
      { clientSecret: string },
      CreateCheckoutRequest
    >({
      query: (req) => ({
        url: `/checkout/session`,
        method: "POST",
        body: req,
      }),
    }),
    getCheckoutSession: builder.query<SessionStatus, string>({
      query: (sessionId) => `/checkout/session/${sessionId}`,
    }),
    checkoutSessionCompleted: builder.mutation<void, { sessionId: string }>({
      query: (req) => ({
        url: `/checkout/session/completed`,
        method: "POST",
        body: req,
      }),
    }),
  }),
});

export const {
  useCreateCheckoutSessionMutation,
  useGetCheckoutSessionQuery,
  useCheckoutSessionCompletedMutation,
} = checkoutApi;

export default checkoutApi;
